module.exports = __webpack_public_path__ + "img/attendance_record.c8a3f804.png";